import wootConstants from 'dashboard/constants/globals';

/**
 * Filters and sorts agents by availability status
 * @param {Array} agents - List of agents
 * @param {string} availability - Availability status to filter by
 * @returns {Array} Filtered and sorted list of agents
 */
export const getAgentsByAvailability = (agents, availability) => {
  return agents
    .filter(agent => agent.availability_status === availability)
    .sort((a, b) => (a.name || '').localeCompare(b.name || ''));
};

/**
 * Ordena os agentes por disponibilidade, SEM PERDER NINGUÉM.
 *
 * ⚠️ ESTA FUNÇÃO SUMIA COM GENTE, e é o defeito que o clube relatou duas vezes.
 *
 * Ela montava a lista com três filtros fixos: online, busy, offline. O FanData tem cinco estados
 * desde o T-103 ('pre_pausa' e 'reuniao', que são almoço e treinamento), então quem estivesse em
 * um deles não entrava em nenhum dos três filtros e DESAPARECIA da lista de atribuição, sem erro
 * e sem aviso. Com o time todo em reunião, a tela "Atribuir Agente" abria vazia.
 *
 * É o que a Izabela mostrou em 15/10 (lista só com o cabeçalho) e, pela mesma causa, o que a
 * Tamara relatou em 14/10: "tentei distribuir de forma manual e mesmo assim não foi".
 *
 * O mesmo defeito já tinha sido corrigido no painel de presença (T-150l), onde o supervisor via
 * como "sumido" quem estava em almoço. Aqui ele custava mais caro, porque não era só a leitura:
 * era a ação.
 *
 * A correção fecha a porta para o próximo estado novo: a ordem vem da lista de estados, e quem
 * tiver um estado fora dela entra no fim, em vez de sumir. Lista de atribuição que esconde gente
 * é pior do que lista fora de ordem.
 *
 * @param {Array} agents - List of agents
 * @returns {Array} Sorted list of agents
 */
export const getSortedAgentsByAvailability = agents => {
  const estados = wootConstants.AVAILABILITY_STATUS_KEYS;
  const conhecidos = new Set(estados);

  const porEstado = estados.flatMap(estado =>
    getAgentsByAvailability(agents, estado)
  );
  const semEstadoConhecido = (agents || [])
    .filter(agent => !conhecidos.has(agent.availability_status))
    .sort((a, b) => (a.name || '').localeCompare(b.name || ''));

  return [...porEstado, ...semEstadoConhecido];
};

/**
 * Updates the availability status of the current user based on the current account
 * @param {Array} agents - List of agents
 * @param {Object} currentUser - Current user object
 * @param {number} currentAccountId - ID of the current account
 * @returns {Array} Updated list of agents with dynamic presence
 */
// Here we are updating the availability status of the current user dynamically
// based on the current account availability status
export const getAgentsByUpdatedPresence = (
  agents,
  currentUser,
  currentAccountId
) => {
  const agentsWithDynamicPresenceUpdate = agents.map(item =>
    item.id === currentUser.id
      ? {
          ...item,
          availability_status: currentUser.accounts.find(
            account => account.id === currentAccountId
          ).availability_status,
        }
      : item
  );
  return agentsWithDynamicPresenceUpdate;
};
